import React, { memo } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export const ComparisonTable = () => {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-68">
      <div className="container mx-auto px-4 md:px-6" data-id="element-69">
        <div className="max-w-4xl mx-auto" data-id="element-70">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-6" data-id="element-71">
            The Real Difference: Pills vs. Setu's Natural Melatonin
          </h2>
          <p className="text-center text-gray-700 mb-10" data-id="element-72">
            We get it. When you're exhausted, any solution sounds tempting. But
            before you choose, here's what you need to know:
          </p>
          <div className="overflow-x-auto" data-id="element-73">
            <table className="w-full border-collapse" data-id="element-74">
              <thead data-id="element-75">
                <tr data-id="element-76">
                  <th className="p-4 text-left bg-gray-50" data-id="element-77"></th>
                  <th className="p-4 text-center bg-red-50 text-red-800 font-bold border-b-2 border-red-200" data-id="element-78">
                    Sleeping Pills
                  </th>
                  <th className="p-4 text-center bg-indigo-50 text-indigo-800 font-bold border-b-2 border-indigo-200" data-id="element-79">
                    Setu's Melatonin
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-80">
                <tr className="border-b border-gray-200" data-id="element-81">
                  <td className="p-4 font-medium text-gray-800" data-id="element-82">
                    How it works
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-83">
                    Forces sedation, disrupts natural sleep cycle
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-84">
                    Supports your body's natural sleep hormone
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-85">
                  <td className="p-4 font-medium text-gray-800" data-id="element-86">
                    Morning feeling
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-87">
                    Groggy, foggy, hungover
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-88">
                    Refreshed, alert, energized
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-89">
                  <td className="p-4 font-medium text-gray-800" data-id="element-90">
                    Dependency risk
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-91">
                    High - body stops producing natural sleep chemicals
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-92">
                    Zero - works with your body's systems
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-93">
                  <td className="p-4 font-medium text-gray-800" data-id="element-94">
                    Sleep quality
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-95">
                    Light, non-restorative sleep
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-96">
                    Deep, natural, restorative sleep cycles
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-97">
                  <td className="p-4 font-medium text-gray-800" data-id="element-98">
                    Side effects
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-99">
                    Dizziness, memory issues, next-day drowsiness
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-100">
                    Minimal to none when used as directed
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-101">
                  <td className="p-4 font-medium text-gray-800" data-id="element-102">
                    Long-term impact
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-103">
                    Tolerance buildup, harder to sleep without them
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-104">
                    Helps restore natural sleep patterns
                  </td>
                </tr>
                <tr data-id="element-105">
                  <td className="p-4 font-medium text-gray-800" data-id="element-106">
                    Wake up time
                  </td>
                  <td className="p-4 text-center text-red-700 bg-red-50" data-id="element-107">
                    Difficult, need multiple alarms
                  </td>
                  <td className="p-4 text-center text-indigo-700 bg-indigo-50" data-id="element-108">
                    Natural, easier wake-ups
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
};